// extracted by mini-css-extract-plugin
export default {"container":"AllResurce_container__a42WG","select":"AllResurce_select__FauK7"};